/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-return */
import { z } from "zod";
import type { FAMILY_RELATION_TYPES } from "../enums";
import { counties } from "../geo/us";

export function getDefaults<T extends z.ZodTypeAny>(
  schema: z.AnyZodObject | z.ZodEffects<any>,
): z.infer<T> {
  // Check if it's a ZodEffect
  if (schema instanceof z.ZodEffects) {
    // Check if it's a recursive ZodEffect
    if (schema.innerType() instanceof z.ZodEffects) return getDefaults(schema.innerType());
    // return schema inner shape as a fresh zodObject
    return getDefaults(z.ZodObject.create(schema.innerType().shape));
  }

  function getDefaultValue(schema: z.ZodTypeAny): unknown {
    if (schema instanceof z.ZodOptional) return undefined;
    if (schema instanceof z.ZodDefault) return schema._def.defaultValue();
    // return an empty array if it is
    if (schema instanceof z.ZodArray) return [];
    // return an empty string if it is
    if (schema instanceof z.ZodString) return "";
    // return an content of object recursivly
    if (schema instanceof z.ZodObject) return getDefaults(schema);

    if (!("innerType" in schema._def)) return null;
    return getDefaultValue(schema._def.innerType);
  }

  return Object.fromEntries(
    Object.entries(schema.shape).map(([key, value]) => {
      return [key, getDefaultValue(value as any)];
    }),
  );
}

export const prettyPrintAddress = (address: {
  city?: string | null;
  county?: string | null;
  locality?: string | null;
  number?: string | null;
  apartment?: string | null;
  postalCode?: string | null;
}) => {
  const { city, county, locality, number, apartment, postalCode } = address;
  const countyFormatted = county ? counties[county.split("/")[1]!]?.name : undefined;
  const addressParts = [city, countyFormatted, locality, number, apartment, postalCode];
  return addressParts.filter((part) => !!part).join(", ");
};

export const slugify = (displayName: string) => {
  return String(displayName)
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9 -]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-");
};

export const slugifyUnique = (displayName: string, maxUniqueStrLength = 9) => {
  const slugified = slugify(displayName);
  return `${slugified}-${Math.random().toString(36).substr(2, maxUniqueStrLength)}`;
};

export const getReverseFamilyRelation = (
  relation: (typeof FAMILY_RELATION_TYPES)[number],
  relativeGender: "M" | "F",
) => {
  switch (relation) {
    case "BROTHER":
      return "BROTHER";
    case "FATHER":
      return "SON";
    case "MOTHER":
      return "SON";
    case "SON":
      return relativeGender === "M" ? "FATHER" : "MOTHER";
    default:
      return "OTHER";
  }
};

export enum SortingDirection {
  ASC = "asc",
  DESC = "desc",
}
